import React from 'react';
import { Grid, makeStyles, withStyles, Card } from '@material-ui/core';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import ObligatoryIcon from "../../icons/ObligatoryIcon";
import RecommendedIcon from "../../icons/RecommendedIcon";
import BasketIcon from '../../icons/BasketIcon';
import Tooltip from '@material-ui/core/Tooltip';
import translate from '../../other/translate.json';
import axios from 'axios';
import config from '../../other/config';
const {serverAPI} = config;

async function loadAppsForCloud(ID, lang) {
  const infoAppsForCloud = await axios.get(`${serverAPI}/clouds/${ID}/${lang}`)
  if (infoAppsForCloud && infoAppsForCloud.data) {
    return infoAppsForCloud.data
  } else {
  }
}

export default function CloudServiceCard(props) {
  const classes = useStyles();
  let { cardArr, setBasketCloud, cloudBasket } = props
  const language = localStorage.getItem('language') || 'Ru'
  const addCloud = async (CloudId) => {
    setBasketCloud(await loadAppsForCloud(CloudId, language), CloudId)
  }

  return (
    cardArr.map(el =>
      <Grid item style={{ width: '100%' }}>
        <Card className={classes.root}>
          <CardContent className={classes.CardContentRoot}>
            <Grid container direction="row" justify="flex-start">
              <Grid item container direction="row" style={{ width: 'calc(100% - 400px)', minWidth: 263 }}>
                {/* <Avatar
                  className={classes.avatar}
                  style={{ backgroundColor: '#8094FF' }}
                // src={}
                >
                  <CloudServiceActiveIcon />
                </Avatar> */}
                <Avatar aria-label="CSCard" className={classes.avatar} src={`${serverAPI}/${el.HashCode}/pict/${el.Icon}`} />

                <a href={`/cloud/${el.url}/overview`} style={{ textDecoration: 'none', maxWidth: 'calc(100% - 62px)' }} rel="noopener noreferrer" target="_blank">
                  <React.Fragment>
                    <Grid container className={classes.InfoCntr} direction='column'>
                      <Typography className={classes.Body2medium}>
                        {el.Title}
                      </Typography>

                      <Typography className={classes.Caption1} style={{ marginTop: 8 }}>
                        {el.BriefDescription}
                      </Typography>
                    </Grid>
                  </React.Fragment>
                </a>
              </Grid>

              <Grid item container direction="column" justify="flex-start" className={classes.container} style={{ margin: 0, width: 264 }}>
                <Grid item style={{ marginBottom: 6 }}>
                  <Typography className={classes.Body2medium}>{translate.Words[`Applications_${language}`]}</Typography>
                </Grid>

                <Grid item container direction="row" className={classes.priceContainer}>
                  <Grid item style={{ width: 24 }}>
                    <ObligatoryIcon fill={'#EB505E'} />
                  </Grid>

                  <Grid item style={{ width: 198 }}>
                    <Typography className={classes.Caption1}>{translate.Words[`LicensingRequired${language}`]}</Typography>
                  </Grid>

                  <Grid item style={{ marginLeft: 25 }}>
                    <Typography className={classes.Caption1} style={{ color: '#24262A' }}>{el.AppsIDsNeededCount}</Typography>
                  </Grid>
                </Grid>

                {el.AppsIDsRecommendedCount === 'null'
                  ?
                  ''
                  :
                  <Grid item container direction="row" className={classes.priceContainer}>
                    <Grid item style={{ width: 24 }}>
                      <RecommendedIcon fill={'#FE9D67'} />
                    </Grid>

                    <Grid item style={{ width: 198 }}>
                      <Typography className={classes.Caption1}>{translate.Words[`RecommendedForLicensing${language}`]}</Typography>
                    </Grid>

                    <Grid item style={{ marginLeft: 25 }}>
                      <Typography className={classes.Caption1} style={{ color: '#24262A' }}>{el.AppsIDsRecommendedCount}</Typography>
                    </Grid>
                  </Grid>
                }
              </Grid>
            </Grid>
          </CardContent>

          <CardActions disableSpacing className={classes.CardActionsRoot}>
            {
              el.AppsIDsNeededCount == 0 && el.AppsIDsRecommendedCount == 0
                ?
                ''
                :
                <CustomTooltip placement="top" title={cloudBasket && cloudBasket.includes(el.ID) ? translate.Words[`RemoveFromBasket${language}`] : translate.Words[`AddTobasket${language}`]}>
                  <IconButton className={classes.icon} onClick={() => addCloud(el.ID)} style={{ backgroundColor: cloudBasket && cloudBasket.includes(el.ID) ? '#EB505E' : '' }}>
                    <BasketIcon fill={cloudBasket && cloudBasket.includes(el.ID) ? '#FFFFFF' : '#BCBBD0'} />
                  </IconButton>
                </CustomTooltip>
            }
          </CardActions>
        </Card >
      </Grid>
    )
  )
}

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'rgba(60, 60, 86, 0.8)',
    color: '#FFFFFF',
    boxShadow: 'none',
    padding: 12,
    borderRadius: 8,
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '14px',
  },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    // height: 418,
    borderRadius: 16,
    boxShadow: 'none',
    padding: '40px 24px 16px'
  },

  CardContentRoot: {
    padding: 0,
    // height: 228
  },

  InfoCntr: {
    height: 76,
    width: '100%',
    maxWidth: 535,
    overflow: 'hidden',
    paddingLeft: theme.spacing(3.25)
  },

  CardActionsRoot: {
    padding: 0,
    paddingTop: 14
  },

  icon: {
    backgroundColor: '#F6F6FB',
    marginLeft: 'auto',
    '&:hover': {
      backgroundColor: '#F6F6FB',
    },
  },

  avatar: {
    height: 62,
    width: 62,
    borderRadius: 24,
    padding: 15,
    backgroundColor: '#EBEEFF',
  },

  Body2medium: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '18px',
    color: '#000000'
  },

  Caption1: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '13px',
    lineHeight: '16px',
    color: '#8987A2'
  },

  priceContainer: {
    padding: '4px 0'
  }
}));